@if(status === undefined && commitSha != undefined && !showFallbackPublicationResult) {
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if( status || conclusion ) {
<div class="status-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Publication Status</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>Depending on how many books you're creating, this may take some time. You can close this window and check the project's <a [href]="project.publicationUrl" target="_blank">distribution page</a> later to see what was created.</p>
      @if( status ) {
        <div class="status-item">
          <mat-icon [ngClass]="getStatusClass(status)" class="status-icon">hourglass_empty</mat-icon>
          <strong>Status:&nbsp;</strong> <span> {{ getStatusMessage(status) }}</span>
        </div>
      }
      @if( conclusion && status === 'completed' ) {
        <div class="status-item">
          <mat-icon [ngClass]="getConclusionClass(conclusion)" class="status-icon">check_circle</mat-icon>
          <strong>Conclusion:&nbsp;</strong> <span> {{ conclusion | titlecase }}</span>
        </div>
      }
      @if( conclusion === 'success' ) {
      <div class="status-item">
        <p>Your files are ready in the project's <a [href]="project.publicationUrl" target="_blank">distribution page</a>.</p>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
}
@if( showFallbackPublicationResult ) {
<div class="status-item">
  <p>The server responded in a way we didn't expect. This is our problem, not yours!</p>
</div>
}